import Button from '@/components/Button';
import ContactFormSheet from '@/components/Landing/ContactFormSheet';
import Text from '@/components/Text';

type Props = {
  title: string;
  description: string;
  primaryLabel?: string;
  onPrimaryClick?: () => void;
};

const CncRfqCtaBanner = ({
  title,
  description,
  primaryLabel = 'Try free demo',
  onPrimaryClick,
}: Props) => {
  return (
    <div className="flex w-full flex-col items-center gap-5 text-center">
      <Text
        variant="display-4"
        className="max-w-[940px] text-center text-jb-neutral-900"
      >
        {title}
      </Text>
      <Text className="max-w-xl text-center text-jb-neutral-800">
        {description}
      </Text>
      <div className="flex flex-row flex-wrap items-center justify-center gap-3">
        <Button
          variant="jbPrimary"
          className="text-[16px] text-neutral-0"
          iconClassName="text-[24px]"
          prefixIcon="material-symbols:play-circle-rounded"
          onClick={onPrimaryClick}
        >
          {primaryLabel}
        </Button>
        <ContactFormSheet sheetTriggerProps={{ asChild: true }}>
          <Button
            variant="cncOutline"
            className="!gap-1 !text-[16px] [&_svg]:!h-6 [&_svg]:!w-6 [&_svg]:!rotate-[-135deg]"
            suffixIcon="material-symbols:arrow-downward"
          >
            Let&apos;s talk
          </Button>
        </ContactFormSheet>
      </div>
    </div>
  );
};

export default CncRfqCtaBanner;
